var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('form-viewer',{staticClass:"col-11 px-0 pb-4",attrs:{"dataShape":_vm.dataShape,"selectedObject":_vm.object,"collectionDBname":_vm.collectionDBname}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }